import React from 'react';
import { Text, TouchableOpacity, View } from 'react-native';
import { OwnershipScopeToggle } from '../../components/OwnershipScopeToggle';
import { COLORS } from '../../constants/theme';
import { styles } from './HomeScreen.styles';

export type HomeViewport = 'mobile' | 'tablet' | 'desktop';

interface HomeHeaderProps {
  readonly viewport: HomeViewport;
  readonly userName?: string;
  readonly userEmail?: string;
  readonly ownershipScope: 'group' | 'self';
  readonly onOwnershipScopeChange?: (value: 'group' | 'self') => void;
  readonly showOwnershipScopeToggle?: boolean;
  readonly onLogout: () => void;
}

export const HomeHeader: React.FC<HomeHeaderProps> = ({
  viewport,
  userName,
  userEmail,
  ownershipScope,
  onOwnershipScopeChange,
  showOwnershipScopeToggle = true,
  onLogout,
}) => {
  const isMobile = viewport === 'mobile';
  const greetingName = userName ? userName : `Hello ${userEmail || 'User'}`;

  return (
    <View
      style={[
        styles.header,
        isMobile ? { backgroundColor: COLORS.primary } : styles.headerTablet,
      ]}
    >
      <View style={styles.headerContentCustomRow}>
        <View>
          <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
            <Text style={isMobile ? styles.greetingCustom : styles.greetingTablet}>
              Hello {greetingName}
            </Text>
            {showOwnershipScopeToggle && (
              <OwnershipScopeToggle
                ownershipScope={ownershipScope}
                onOwnershipScopeChange={onOwnershipScopeChange}
              />
            )}
          </View>
          <Text style={isMobile ? styles.welcomeTextCustom : styles.welcomeTextTablet}>
            Welcome back
          </Text>
        </View>
        {isMobile && (
          <TouchableOpacity style={styles.logoutButton} onPress={onLogout}>
            <Text style={styles.logoutIcon}>⏻</Text>
          </TouchableOpacity>
        )}
      </View>
    </View>
  );
};
